import { render, staticRenderFns } from "./no-content-block.vue?vue&type=template&id=be7efa98&scoped=true"
import script from "./no-content-block.vue?vue&type=script&lang=js"
export * from "./no-content-block.vue?vue&type=script&lang=js"
import style0 from "./no-content-block.vue?vue&type=style&index=0&id=be7efa98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7efa98",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconGrayLogo: require('/app/components/icons/IconGrayLogo.vue').default})
